import { Module, Action, getModule, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { CodeLabel, CodeLabelInfo } from '@/tcw/api/types'
import { TCWDataLoadError } from '@/plugins/TCWBaseError'

/**
 * メッセージSTORE
 */
@Module({
  name: 'CodeLabelStoreModule',
  store,
  namespaced: true,
  dynamic: true
})
export default class CodeLabelStoreModule extends VuexModule {
  private codeLabelInfo: CodeLabelInfo | null = null

  /****************
   * Mutation
   ****************/
  @Mutation
  private setCodeLabelInfo(codeLabelInfo: CodeLabelInfo | null): void {
    this.codeLabelInfo = codeLabelInfo
  }

  /****************
   * Getter
   ****************/
  public get has(): boolean {
    return this.codeLabelInfo !== null
  }
  public get get(): CodeLabelInfo | null {
    return this.codeLabelInfo
  }

  /****************
   * Action
   ****************/
  /**
   * 新規データ作成
   */
  @Action
  public set(codeLabelInfo: CodeLabelInfo): void {
    this.setCodeLabelInfo(codeLabelInfo)
  }
  /**
   */
  @Action
  public clear(): void {
    this.setCodeLabelInfo(null)
  }
  /**
   */
  @Action({ rawError: true })
  public async getCodeLabelList(keyClass: string): Promise<CodeLabel[]> {
    if (this.codeLabelInfo === null) {
      throw new TCWDataLoadError('マスタデータが取得されていません')
    }

    let codeLabelList = this.codeLabelInfo[keyClass]
    if (codeLabelList === undefined) {
      throw new TCWDataLoadError('マスタデータが取得されていません。KeyClass: ' + keyClass)
    }

    // 順番でソート
    codeLabelList = codeLabelList.sort((a: CodeLabel, b: CodeLabel) => {
      const [aJunban, bJunban] = [a.junban ? a.junban : 0, b.junban ? b.junban : 0]
      return aJunban - bJunban
    })

    return codeLabelList
  }
  /**
   */
  @Action({ rawError: true })
  public async getLabelByCode(keyInfo: {
    keyClass: string
    code: string | number
  }): Promise<string> {
    const codeLabelList = await this.getCodeLabelList(keyInfo.keyClass)
    const codLabel = codeLabelList.find((cl: CodeLabel) => String(cl.code) === String(keyInfo.code))
    if (codLabel === undefined) {
      throw new TCWDataLoadError(
        `マスタデータが取得されていません。KeyClass: ${keyInfo.keyClass}, Code: ${keyInfo.code}`
      )
    }
    return codLabel.label
  }
  /**
   */
  public getCodeLabelListImmediately(keyClass: string): CodeLabel[] {
    if (this.codeLabelInfo === null) {
      throw new TCWDataLoadError('マスタデータが取得されていません')
    }

    let codeLabelList = this.codeLabelInfo[keyClass]
    if (codeLabelList === undefined) {
      throw new TCWDataLoadError('マスタデータが取得されていません。KeyClass: ' + keyClass)
    }

    // 順番でソート
    codeLabelList = codeLabelList.sort((a: CodeLabel, b: CodeLabel) => {
      const [aJunban, bJunban] = [a.junban ? a.junban : 0, b.junban ? b.junban : 0]
      return aJunban - bJunban
    })

    return codeLabelList
  }
  /**
   */
  @Action({ rawError: true })
  public getLabelByCodeImmediately(keyInfo: { keyClass: string; code: string | number }): string {
    const codeLabelList = this.getCodeLabelListImmediately(keyInfo.keyClass)
    const codLabel = codeLabelList.find((cl: CodeLabel) => String(cl.code) === String(keyInfo.code))
    if (codLabel === undefined) {
      throw new TCWDataLoadError(
        `マスタデータが取得されていません。KeyClass: ${keyInfo.keyClass}, Code: ${keyInfo.code}`
      )
    }
    return codLabel.label
  }
}

export const codeLabelStore = getModule(CodeLabelStoreModule)
